<template>
  <v-dialog
    :value="show"
    persistent
    max-width="750px"
    transition="dialog-transition"
    @input="closeModal"
  >
    <v-card>
      <v-card-title>
        <v-container grid-list-lg fluid py-0>
          <v-layout row wrap>
            <v-flex xs12>
              <h2>
                {{ title }}
              </h2>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-lg fluid py-0>
          <v-layout row wrap py-2>
            <v-flex xs11>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-select
                    attach
                    color="black"
                    :items="allFilters"
                    v-model="selected"
                    item-text="text"
                    item-value="value"
                    label="Filtros"
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-select
                    attach
                    color="black"
                    :label="selected === '' ? '...' : getLabel()"
                    item-value="id"
                    item-text="name"
                    v-model="selectedValue"
                    :items="selectedStore"
                    :disabled="!selectedStore.length">
                  </v-select>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs1
              d-flex
              align-center
              text-xs-center>
              <v-btn
                depressed
                slot="activator"
                class="btn-add"
                :class="{ 'k-orange-linear': selected !== '' && selectedValue !== '', 'blue-grey lighten-4': selected === '' || selectedValue === '' }"
                :disabled="selected === '' || selectedValue === ''"
                @click="add">
                <v-icon>fa-check</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <vue-perfect-scrollbar :settings="settings">
                <v-container class="px-2 py-0" grid-list-lg fluid style="height: 300px;">
                  <transition-group name="fade">
                    <v-layout row wrap justify-center align-center v-for="(filter, index) in addedFilters" :key="`filter-${index}`">
                      <v-flex xs11 class="bordered">
                        <v-layout row wrap >
                          <v-flex xs2>
                            <v-icon small>fa-filter</v-icon>
                          </v-flex>
                          <v-flex xs10>
                            <v-layout row wrap>
                              <v-flex xs6>
                                {{ getText(filter) }}
                              </v-flex>
                              <v-flex xs6 text-xs-righ>
                                <template v-if="filter.key === 'channel' || filter.key.includes('channel_id')">
                                  <!-- <p v-for="(key, idx) in _self[filter.key].filter(item => filter[filter.key].includes(item.id))" :key="`key-${idx}`">
                                    {{ getChannelField('id', key.id, 'name') }}
                                  </p> -->
                                  {{ getChannelField('id', getObject(filter).id, 'name') }}
                                </template>
                                <template v-else>
                                  <!-- <p v-for="(key, idx) in _self[filter.key].filter(item => filter[filter.key].includes(item.id))" :key="`key-${idx}`">
                                    {{ key.name }}
                                  </p> -->
                                  {{ filter.key === 'status' ?  getObject(filter).status : getObject(filter).name }}
                                </template>
                                <template v-if="filter.key === 'due_day' || filter.key === 'tranche'">
                                  días
                                </template>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs1>
                        <v-btn color="k-orange-linear" depressed small icon @click="remove(index)">
                          <v-icon small>fa-times</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </transition-group>
                </v-container>
              </vue-perfect-scrollbar>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-layout row wrap justify-end>
          <v-flex shrink>
            <v-btn flat color="black" @click="closeModal(true)">
              CANCELAR
            </v-btn>
          </v-flex>
          <v-flex shrink>
            <v-btn class="k-orange-linear-text" flat @click="applyFilter">
              FILTRAR
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import ChannelMixin from '@/mixins/channels';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  props: {
    title: {
      type: String,
      default: 'Filtros',
    },
    show: {
      type: Boolean,
      required: true,
    },
    customFilters: {
      type: Array,
      default: () => [],
    },
    deafultFilters: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [
    ChannelMixin,
  ],
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      selected: '',
      addedFilters: [],
      selectedValue: '',
      ns_stage_id: [
        {
          id: 1,
          name: 'No Gestionado',
        },
        {
          id: 2,
          name: 'No Contactado',
        },
        {
          id: 3,
          name: 'Contactado',
        },
        {
          id: 4,
          name: 'Contacto util',
        },
        {
          id: 5,
          name: 'Compromiso de pago',
        },
      ],
      type: [
        {
          name: 'Carga diaria',
          id: 1,
        },
        {
          name: 'Campañas',
          id: 2,
        },
      ],
      settings: {
        suppressScrollX: true,
      },
    };
  },
  computed: {
    ...mapGetters({
      agent: 'agents',
      state: 'states',
      gender: 'genders',
      status: 'statuses',
      agency: 'agencies',
      tranche: 'tranches',
      due_day: 'due_dates',
      age_group: 'age_groups',
      dimention: 'dimentions',
      account_type: 'account_types',
      portfolio_type: 'portfolio_types',
      customer_status: 'customerStatuses',
      workflow_status: 'customerStatuses',
      trancheStatus: 'trancheStatuses',
      channelsAll: 'channels',
    }),
    allFilters() {
      const defaultFilters = [
        {
          text: 'Agente',
          value: 'agent',
        },
        {
          text: 'Genero',
          value: 'gender',
        },
        {
          text: 'Estado / Región',
          value: 'state',
        },
        {
          text: 'Tramo',
          value: 'tranche',
        },
        {
          text: 'Agencia',
          value: 'agency',
        },
        {
          text: 'Grupo de edad',
          value: 'age_group',
        },
        {
          text: 'Vencimiento',
          value: 'due_day',
        },
        {
          text: 'Tipo de cuenta',
          value: 'account_type',
        },
        {
          text: 'Cartera',
          value: 'portfolio_type',
        },
      ];
      const dim = this.dimention.map(item => ({
        text: item.title,
        value: item.name,
      }));
      const filters = _.chain([
        ...this.customFilters,
        ...dim,
        ...defaultFilters,
      ]).uniqBy('text')
        .filter('value')
        .value();
      return filters;
    },
    selectedStore() {
      if (this.selected === '') {
        return [];
      }
      let store = this[this.selected];
      if (this.selected === 'channel' || this.selected.includes('channel_id')) {
        store = this.channelsAll;
        return store.map(item => ({
          id: item.id,
          name: this.getChannelField('channel', item.channel, 'name'),
        }));
      }
      if (this.selected.includes('_name')) {
        const name = this.selected === 'first_name' ? 'nombre' : 'apellido';
        return [
          {
            id: 2,
            name: `Sin ${name}`,
          },
          {
            id: 1,
            name: `Con ${name}`,
          },
        ];
      }
      if (this.selected === 'status') {
        return store.map(item => ({
          id: item.id,
          name: item[this.selected],
        }));
      }
      if (this.selected.includes('dim_')) {
        return this.dimention.find(item => item.name === this.selected).items;
      }
      return store;
    },
  },
  methods: {
    closeModal($event) {
      if ($event) {
        this.$emit('close');
      }
    },
    add() {
      const filters = this.addedFilters;
      const index = filters.findIndex(item => item[this.selected] !== undefined);
      if (index > -1) {
        filters[index][this.selected] = this.selectedValue;
        // const idx = filter.findIndex(item => item === this.selectedValue);
        // if (idx === -1) {
        //   filter.push(this.selectedValue);
        // }
      } else {
        filters.push({
          key: this.selected,
          // [this.selected]: [this.selectedValue],
          [this.selected]: this.selectedValue,
        });
      }
      this.selected = '';
      this.selectedValue = '';
    },
    getObject(filter) {
      if (filter.key.includes('dim_')) {
        // return this.dimention.find(item => item.name === filter.key)
        // .items.find(item => filter[filter.key].includes(item.id));
        return this.dimention.find(item => item.name === filter.key)
          .items.find(item => filter[filter.key] === item.id) || {};
      }
      if (filter.key.includes('channel_id')) {
        return this.channelsAll.find(item => filter[filter.key] === item.id) || {};
      }
      if (filter.key.includes('_name')) {
        const name = filter.key === 'first_name' ? 'nombre' : 'apellido';
        const items = [
          {
            id: 2,
            name: `Sin ${name}`,
          },
          {
            id: 1,
            name: `Con ${name}`,
          },
        ];
        return items.find(x => x.id === filter[filter.key]);
      }
      // return this[filter.key].find(item => filter[filter.key].includes(item.id))
      return this[filter.key].find(item => filter[filter.key] === item.id) || {};
    },
    getText(filter) {
      const text = this.allFilters.find(item => item.value === filter.key);
      if (text) {
        return text.text;
      }
      return '';
    },
    getLabel() {
      let labels = {
        agent: 'Agentes',
        state: 'Estados / Regiones',
        gender: 'Generos',
        agency: 'Agencias',
        status: 'Estatus',
        channel: 'Canales',
        tranche: 'Tramos',
        due_day: 'Vencimiento',
        age_group: 'Grupos de edad',
        dimention: 'Dimension',
        account_type: 'Tipos de cuenta',
        portfolio_type: 'Carteras',
        customer_status: 'Estatus',
      };
      if (this.dimention.length) {
        labels = {
          ...labels,
          ...this.dimention.reduce((carry, item) => ({
            ...carry,
            [item.name]: item.title,
          }), {}),
        };
      }
      return labels[this.selected];
    },
    applyFilter() {
      if (this.selected !== '' && this.selectedValue !== '') {
        this.add();
      }
      this.$emit('filter', this.addedFilters.reduce((carry, item) => ({
        ...carry,
        [item.key]: item[item.key],
      }), {}));
    },
    remove(index) {
      this.$emit('removeFilter', this.addedFilters[index].key);
      this.addedFilters.splice(index, 1);
    },
  },
  watch: {
    show() {
      this.addedFilters = [];
      const keys = Object.keys(this.deafultFilters);
      keys.forEach((key) => {
        if ((this[key] && this[key].length) || key.includes('dim_')) {
          const filters = this.addedFilters;
          const index = filters.findIndex(item => item[key] !== undefined);
          if (index === -1) {
            filters.push({
              key,
              [key]: this.deafultFilters[key],
            });
          }
        } else if (key.includes('channel_id') || key.includes('_name')) {
          const filters = this.addedFilters;
          const index = filters.findIndex(item => item[key] !== undefined);
          if (index === -1) {
            filters.push({
              key,
              [key]: this.deafultFilters[key],
            });
          }
        }
      });
    },
    selected() {
      this.selectedValue = '';
    },
  },
};
</script>
<style scoped>
  .bordered {
    border: 1px solid #d3d3d3;
    border-radius: 6px;
  }
  .btn-add {
    margin: 0;
    padding: 0;
    min-width: 100%;
    border-radius: 6px;
  }
  .fade-enter-active, .fade-leave-active {
    transition: all .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>





// WEBPACK FOOTER //
// src/components/global/FilterModal.vue